import React from 'react';
import { Link } from 'react-router-dom';
import LogoSoft from "../img/LOGOSTOCK360.png"; // Asegúrate de tener la ruta correcta al logo
import SidebarAdmin from "./sidebars/sidebarAdmin";

const Sidebar = () => {

  const activeMenu = (event) => {
    const sidebar = document.getElementById("sidebar");
    const menus = sidebar.getElementsByClassName("active");
    for (let index = 0; index < menus.length; index++) {
      const element = menus[index];
      element.className = element.className.replace("active", "");
    }
    const item =
      event.target.tagName === "SPAN" || event.target.tagName === "I"
        ? event.target.parentNode
        : event.target;
    item.parentNode.className = "sidebar-item active";
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const showMenus = (event) => {
    const item =
      event.target.tagName === "SPAN" || event.target.tagName === "I"
        ? event.target.parentNode
        : event.target;
    const closed = item.className.includes("collapsed");
    item.className = closed ? "sidebar-link" : "sidebar-link collapsed";
    const subMenuList =
      item.parentNode.getElementsByClassName("sidebar-dropdown");
    if (subMenuList && subMenuList.length > 0) {
      for (let i = 0; i < subMenuList.length; i++) {
        subMenuList[i].getElementsByClassName("sidebar-dropdown");
        if (closed) {
          subMenuList[i].className =
            "sidebar-dropdown list-unstyled collapse show";
        } else {
          subMenuList[i].className = "sidebar-dropdown list-unstyled collapse";
        }
      }
    }
  };

  return (
    <nav id="sidebar" className="sidebar">
      <div className="sidebar-content js-simplebar">
        <Link to="/heropro/dashboard" className="sidebar-brand">
          <span className="align-middle me-3">
            <img
              src={LogoSoft}
              alt="Logo de Stock360"
              width="90"
              height="90"
            />
            <br />
            <span className="light-text">STOCK360</span>
            <br />
            <span className="light-text small">Logística Avanzada</span>
          </span>
        </Link>
        <SidebarAdmin showMenus={showMenus} activeMenu={activeMenu} />
      </div>
    </nav>
  );
};

export default Sidebar;
